import ServiceDetailLayout from '../../components/ServiceDetailLayout';

export default function WebsiteDevelopmentPage() {
  return <ServiceDetailLayout slug="website-development" />;
}
